module.exports = __webpack_public_path__ + "static/ally-POR-c2d477d1b394238899fa8d5a0936e5e3.png";